'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.millisecondBefore;


// WEBPACK FOOTER //
// ./~/sugar-date/number/millisecondBefore.js